/* Progressive enhancement: with JavaScript disabled, collection panels remain visible. */
if (!customElements.get('yop-collections')) {
  customElements.define('yop-collections', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-yop-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-yop-panel]'));
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-yop-tab]');
        if (!tab || !this.contains(tab) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(tab.dataset.yopTab);
      });
      this.addEventListener('keydown', (event) => {
        const active = this.tabs.indexOf(event.target);
        if (active < 0) return;
        let target;
        if (event.key === 'ArrowRight') target = (active + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') target = (active + this.tabs.length - 1) % this.tabs.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = this.tabs.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        this.tabs[target].focus();
        this.select(this.tabs[target].dataset.yopTab);
      });
      this.select('all');
    }
    select(key) {
      if (!this.panels.some(panel => panel.dataset.yopPanel === key)) return;
      this.tabs.forEach(tab => {
        if (tab.dataset.yopTab === key) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.yopPanel !== key; });
    }
  });
}
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-yop-disclosure][open]').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
    if (details.classList.contains('yop-mobile-menu') && event.target.closest('a')) details.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const opened = [...document.querySelectorAll('[data-yop-disclosure][open]')];
  const target = opened.find(details => details.contains(document.activeElement)) || opened.at(-1);
  opened.forEach(details => { details.open = false; });
  target?.querySelector('summary')?.focus();
});
